import {Component, HostListener} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Router} from '@angular/router';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
    faAngleLeft,
    faAngleRight,
    faCar,
    faCheck,
    faCircleXmark,
    faFileExcel,
    faMagnifyingGlass,
    faPen,
    faPenToSquare,
    faSquarePlus,
    faTrash,
    faUpload
} from '@fortawesome/free-solid-svg-icons';
import {ApiService} from '../../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {getFileNameFromResponse} from '../../../common/utils';
import saveAs from 'file-saver';
import {GenericSearchComponent} from '../../shared/search-suggestion/search-suggestion.component';
import {VehicleNumberCopyDirective} from '../../shared/vehicle-number-copy/vehicle-number-copy.directive';
import {BulkImportResultComponent} from '../../shared/bulk-import-result/bulk-import-result.component';
import {
    BulkImportResultView,
    handleBulkImportError,
    handleBulkImportFallbackError,
} from '../../shared/bulk-import-result/bulk-import-result.utils';
import {DEFAULT_TABLE_PAGE_SIZE_OPTIONS} from '../../shared/constants/pagination.constants';


@Component({
    selector: 'app-black-listed-vehicle',
    templateUrl: './black-listed-vehicle.component.html',
    styleUrl: './black-listed-vehicle.component.css',
    imports: [CommonModule, FormsModule, FontAwesomeModule, GenericSearchComponent, VehicleNumberCopyDirective, BulkImportResultComponent]
})
export class BlackListedVehicleComponent {
    readonly pageSizeOptions = DEFAULT_TABLE_PAGE_SIZE_OPTIONS;

  searchText: string | null = '';
  recordsPerPage: number = 10;
  currentPage: number = 1;
  blackedVehicle:any = []; 
  nextPage: number | null = null;
  previousPage: number | null = null;
  limit: number = 10;
  showConfirmationDialog: boolean = false;
  pId: number = 0;
  totalRecords:number = 0;
  showReason: Boolean = false;
  reason: string = '';
  role: string = ''
  todayDate: Date = new Date();
  hoverRowId: number | null = null;
  bulkImportResult: BulkImportResultView | null = null;


  constructor(private apiService: ApiService, library: FaIconLibrary, private router: Router,  private toastr:ToastrService) {
    this.fetchData(this.currentPage, this.recordsPerPage);
    library.addIcons(faTrash,
                    faFileExcel,
                    faAngleRight,
                    faAngleLeft,
                    faUpload,
                    faSquarePlus,
                    faMagnifyingGlass,
                    faPen,
                    faPenToSquare,
                    faCar,
                    faCheck,
                    faCircleXmark
                  );
    
    let user = localStorage.getItem('user');
    if (user){
      const userObj = JSON.parse(user)
      this.role = userObj['groups']
    }
    
  }

  fetchData(page: number, pageSize: number){
    this.apiService.getBlackedVehicle(page, pageSize, this.searchText).subscribe({
      next: (data: any) => {
      this.blackedVehicle = data['results'];
      this.totalRecords = data['count'];
      this.nextPage = data['next']
      this.previousPage = data['previous']
    }
  });
  }
 
  get totalPages(): number {
    let totalPage =  Math.ceil(this.totalRecords / this.recordsPerPage);
      if (totalPage === 0){
        totalPage = 1;
      }
      return totalPage;
    }

  next() {
    if (this.nextPage){
      this.currentPage++;
      this.fetchData(this.currentPage, this.recordsPerPage)
    }
  }

  previous() {
    if (this.previousPage){
      this.currentPage--;
      this.fetchData(this.currentPage, this.recordsPerPage)
      }
  }

  selectPageSize(){
    if(this.recordsPerPage){
      this.currentPage = 1;
      this.fetchData(this.currentPage, this.recordsPerPage)
    }
  }
  openConfirmationDialog(index: number) {
    this.showConfirmationDialog = true;
    this.pId = index;
  }

  closeConfirmationDialog() {
    this.showConfirmationDialog = false;
  }

  confirmUnblack() {
    this.apiService.unblack(this.pId).subscribe({
      next: (response:any) => {
        this.toastr.success('Whitelisted successfully.', 'Success');
        this.closeConfirmationDialog();
        // window.location.reload();
        window.location.href = '/blacked-vehicle'
      },
      error: (err) => {
        if (err['error']['detail']) {
            this.toastr.error(err['error']['detail'], 'Error');
          
        }  else if (err['status'] !== 403 && err.status !== 0) {
          this.toastr.error("Something went wrong!", 'Error');
        }
        this.closeConfirmationDialog();
      }
    })
  }

  vehicleSearch(){
  }

  exportToExcel() {
      this.apiService.exportBlacklisted(this.currentPage, this.recordsPerPage, this.searchText).subscribe({
            next: (response: any) => {
              const fileName = getFileNameFromResponse(response);
                if (response.body) {
                    saveAs(response.body, fileName);
                }
             
            },
            error: (err) => {
              this.toastr.error(`${err}`, 'Error')
            }
          })
  }
  
  addvehicleInBlackList(){
    this.router.navigate(['/add-vehicle-black-list'])

  }


   openReason(reason: string) {
    this.reason = reason;
    this.showReason = true;
  }

  closeReason() {
    this.showReason = false;
  }
  
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const modalElement = document.querySelector('.modal-content');
    if (modalElement && !modalElement.contains(target)) {
      this.showReason = false;
    }
  }
  onResults(event: { searchText: string, results: any[], totalRecords: number, nextPage: number | null, previousPage: number | null }) {
  this.currentPage = 1;
  this.recordsPerPage = 10;
  this.previousPage = event.previousPage;
  this.nextPage = event.nextPage;
  this.searchText = event.searchText;
  this.blackedVehicle = event.results;
  this.totalRecords = event.totalRecords;
}

    downloadTemplate() {
        this.apiService.downloadImportTemplate('blocklist').subscribe({
            next: (response) => {
                const fileName = getFileNameFromResponse(response);
                if (response.body) {
                    saveAs(response.body, fileName);
                }
            },
            error: (err) => handleBulkImportFallbackError(err, this.toastr),
        });
    }

    uploadBulkFile(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) {
            return;
        }

        this.bulkImportResult = null;
        const formData = new FormData();
        formData.append('file', file);
        this.apiService.bulkUploadBlocklist(formData).subscribe({
            next: (response: any) => {
                this.bulkImportResult = null;
                this.toastr.success(response?.message || 'Blocklist records uploaded successfully.', 'Success');
                this.fetchData(this.currentPage, this.recordsPerPage);
                input.value = '';
            },
            error: (err) => {
                this.bulkImportResult = handleBulkImportError(err, this.toastr, 'blocklist_bulk_upload_failures.csv');
                input.value = '';
            },
        });
    }
}
